module.exports = ".fotter-tcm\n{\n    font-family: Roboto-Regular;\n    font-size: 15px;\n    color: #707070 !important;       \n}\n.fotter-tcm a\n{\n    color: #707070 !important; \n    margin-right: 10px;\n    margin-left: 10px;      \n}\n.fotter-tcm ul {\n    padding: 0px;\n    list-style: none;\n}\n.fotter-tcm ul li{\n    display: inline !important;\n}\na:hover {\n    text-decoration: none;\n}\n.fotter-tcm{\n    margin-top: 50px !important;\n}\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./public/app/common/footer/footer.component.css
// module id = ./public/app/common/footer/footer.component.css
// module chunks = main